import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TransportLine } from '../../../common/models/TransportLine.Model';
import { SettingsService } from '../../../../core/settings/settings.service';
import { TransportLineService } from '../transport-line.service';
import { toNumber } from 'lodash';
import { UserLogin } from '../../../common/models/UserLogin.Model';
import { GlobalFunctionsService } from 'src/app/ceq/common/functions/global-functions.service';

@Component({
  selector: 'app-transport-line-detail',
  templateUrl: './transport-line-detail.component.html',
  styleUrls: ['./transport-line-detail.component.scss']
})
export class TransportLineDetailComponent implements OnInit {

  line: TransportLine = new TransportLine();
  userLogin: UserLogin;
  isNew: boolean = false;

  constructor(
    private url: ActivatedRoute,
    private settings: SettingsService,
    private transportLineService: TransportLineService,
    private globalFunctionService: GlobalFunctionsService
  ) { }

  ngOnInit(): void {
    this.userLogin = this.settings.getUser();
    const currentId = this.url.snapshot.paramMap.get('id');
    
    this.line.Org = this.userLogin.Org;

    if (this.isNullOrWhitespace(currentId) || currentId === 'create') {
      this.isNew = true;
      this.line.TransportLineId = 0;
    } else {
      this.isNew = false;
      this.line.TransportLineId = toNumber(currentId);
      this.getFiscalConfig();
    }
  }

  getFiscalConfig() {
    this.transportLineService.getLineById(this.line.TransportLineId).subscribe({
      next: (data) => {
        this.line = data;
      },
      error: async () => {
        await this.globalFunctionService.messageBimbo("No se encontró la línea de transporte solicitada", 'error', '¡Error!');
        this.btnCancelOnClick();
      }
    });
  }

  formSubmit() {
    const operation = this.isNew 
      ? this.transportLineService.newLine(this.line)
      : this.transportLineService.updateLine(this.line);

    operation.subscribe({
      next: async () => {
        const msg = this.isNew ? 'Línea de transporte creada' : 'Línea de transporte actualizada';
        await this.globalFunctionService.messageBimbo(msg, 'success', '¡Éxito!');
        this.btnCancelOnClick();
      },
      error: async (err) => {
        const errorMsg = err.error || 'Ocurrió un error al procesar la solicitud';
        await this.globalFunctionService.messageBimbo(errorMsg, 'error', '¡Error!');
      }
    });
  }

  btnCancelOnClick() {
    // Mantenemos window.close() porque el listado abre este componente en _blank
    window.close();
  }

  private isNullOrWhitespace(input: any): boolean {
    return !input || input.toString().trim().length < 1;
  }
}